<template>
  <v-layout align-center justify-center row pa-5 class="mb-12">
    <v-flex xs12 sm10 md6>
      <div class="mb-5 text-center">
        <h3>ตรวจสอบข้อมูล และยืนยัน</h3>
        <h1>ข้อมูลพัสดุ</h1>
      </div>
      <v-row>
        <v-col><b>บ้านเลขที่</b></v-col>
        <v-col class="text-right">{{ pd_addr }}</v-col>
      </v-row>
      <v-row>
        <v-col><b>ยูนิต</b></v-col>
        <v-col class="text-right">{{ pd_unit }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><b>ชื่อผู้รับ</b></v-col>
        <v-col class="text-right">{{ cs_fullname }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><b>เบอร์โทร</b></v-col>
        <v-col class="text-right" v-if="!edit">{{ cs_mobile }}
          <v-icon class="ml-2" @click="edit = !edit">mdi-pencil</v-icon>
        </v-col>
        <v-col v-else>
          <v-text-field outlined
                        dense
                        v-model="cs_mobile"
                        type="number"
                        append-outer-icon="mdi-check"
                        autofocus
                        @click:append-outer="edit = !edit">
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><b>เลขทะเบียน</b></v-col>
        <v-col class="text-right">{{ barcode }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><b>ขนส่ง</b></v-col>
        <v-col class="text-right">{{ logisticName }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><b>ลักษณะ</b></v-col>
        <v-col class="text-right">{{ parcelTypeName }}</v-col>
      </v-row>
      <v-row align="center" v-if="imageUrl">
        <v-col cols="4"><b>รูปพัสดุ</b></v-col>
        <v-col align="right">
          <v-img width="150" :src="imageUrl"></v-img>
        </v-col>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "@/axios";
import EventBus from '@/EventBus'

export default {
  name: "Step6",
  props: {
    step: Number
  },
  data() {
    return {
      pd_addr: null,
      pd_unit: null,
      cs_fullname: null,
      cs_mobile: null,
      logisticName: null,
      parcelTypeName: null,
      barcode: null,
      edit: false,
      imageUrl: null,
    }
  },
  mounted() {
    // this.pd_addr = this.getLocalItem().dataSelect.pd_addr
    // this.pd_unit = this.getLocalItem().dataSelect.pd_unit
    // this.cs_fullname = this.getLocalItem().dataSelect.cs_fullname
    // this.cs_mobile = this.getLocalItem().dataSelect.cs_mobile
    // this.logisticName = this.getLocalItem().logisticName
    // this.parcelTypeName = this.getLocalItem().parcelTypeName
    // this.barcode = this.getLocalItem().barcode
    // this.imageUrl = this.getLocalItem().imageUrl
  },
  methods: {
    goto(route_name, params) {

    }
  },
  watch: {
    step: function (val) {
      // console.log(val)
      if (val === 6) {
        this.pd_addr = this.getLocalItem().dataSelect.pd_addr
        this.pd_unit = this.getLocalItem().dataSelect.pd_unit
        this.cs_fullname = this.getLocalItem().dataSelect.cs_fullname
        this.cs_mobile = this.getLocalItem().dataSelect.cs_mobile
        this.logisticName = this.getLocalItem().logisticName
        this.parcelTypeName = this.getLocalItem().parcelTypeName
        this.barcode = this.getLocalItem().barcode
        this.imageUrl = this.getLocalItem().imageUrl
      }
    },
    cs_mobile: function (val) {
      let localItem = this.getLocalItem();
      localItem.dataSelect.cs_mobile = val
      localStorage.setItem('parcel', JSON.stringify(localItem))
    }
  }
}
</script>

<style scoped>

</style>